import React, { useEffect, useState } from "react";
import { Typography, Button } from "antd";
import { ArrowLeftOutlined, CheckCircleFilled } from "@ant-design/icons";
import success from "../../Images/PaySuccess.gif";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

function PaymentSuccess({ sidebarCollapsed = false }) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Listen to window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Sidebar widths
  const SIDEBAR_WIDTH = 200; // expanded
  const SIDEBAR_COLLAPSED = 80; // collapsed
  const SIDE_GAP = 10; // extra gap between sidebar and card

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "#f5f7fb",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          padding: isMobile ? "0 16px" : 0,
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: isMobile ? "100%" : 520,
            maxWidth: "100%",
            background: isMobile ? "#fff" : "transparent",
            border: isMobile ? "1px solid #1677ff" : "none",
            borderRadius: isMobile ? 12 : 0,
            padding: isMobile ? 16 : 0,
            textAlign: "center",
            boxSizing: "border-box",
          }}
        >
          <img
            src={success}
            alt="Payment Success"
            style={{
              display: "block",
              margin: "0 auto",
              maxWidth: "100%",
              objectFit: "contain",
              height: isMobile ? "34vh" : "40vh",
            }}
          />

          <Title
            level={isMobile ? 4 : 3}
            style={{
              margin: "8px 0 4px",
              color: "green",
              wordBreak: "break-word",
            }}
          >
            <CheckCircleFilled style={{ marginRight: 6 }} />
            Payment Successful
          </Title>

          <Text
            strong
            style={{
              display: "block",
              fontSize: isMobile ? 14 : 16,
              marginBottom: 6,
              marginTop: 2,
              wordBreak: "break-word",
            }}
          >
            Thank you! Your payment of Rs 5200/- has been received
          </Text>

          <Text
            type="secondary"
            style={{
              display: "block",
              fontSize: isMobile ? 13 : 14,
              marginBottom: 8,
              wordBreak: "break-word",
            }}
          >
            Order Id: 23432 | Transaction Id: 2342355
          </Text>

          <Button
            type="text"
            icon={
              <ArrowLeftOutlined style={{ fontSize: isMobile ? 16 : 18 }} />
            }
            onClick={() => navigate(-1)}
            style={{
              padding: 0,
              fontSize: isMobile ? 16 : 18,
              color: "#1677ff",
              fontWeight: 500,
            }}
          >
            Back
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
